import { createSelector } from 'reselect'
import api from './api'
import { combineReducers } from '../../node_modules/redux'

const stateReservationsSelector = (state) => state.reservation

export const selector = createSelector(
    [stateReservationsSelector],
    (reservation) => {
        return { ...reservation }
    }
)

const RESERVATION__GET_REQUEST = 'RESERVATION__GET_REQUEST'
const RESERVATION__GET_SUCCESS = 'RESERVATION__GET_SUCCESS'
const RESERVATION__GET_FAILURE = 'RESERVATION__GET_FAILURE'

const RESERVATION__GET_CONFIRMATION_REQUEST = 'RESERVATION__GET_CONFIRMATION_REQUEST'
const RESERVATION__GET_CONFIRMATION_SUCCESS = 'RESERVATION__GET_CONFIRMATION_SUCCESS'
const RESERVATION__GET_CONFIRMATION_FAILURE = 'RESERVATION__GET_CONFIRMATION_FAILURE'

const RESERVATION__UPDATE_RESERVATION_REQUEST = 'RESERVATION__UPDATE_RESERVATION_REQUEST'
const RESERVATION__UPDATE_RESERVATION_SUCCESS = 'RESERVATION__UPDATE_RESERVATION_SUCCESS'
const RESERVATION__UPDATE_RESERVATION_FAILURE = 'RESERVATION__UPDATE_RESERVATION_FAILURE'

const RESERVATION__GET_INVENTORY_REQUEST = 'RESERVATION__GET_INVENTORY_REQUEST'
const RESERVATION__GET_INVENTORY_SUCCESS = 'RESERVATION__GET_INVENTORY_SUCCESS'
const RESERVATION__GET_INVENTORY_FAILURE = 'RESERVATION__GET_INVENTORY_FAILURE'

const RESERVATION__CHECKIN_REQUEST = 'RESERVATION__CHECKIN_REQUEST'
const RESERVATION__CHECKIN_SUCCESS = 'RESERVATION__CHECKIN_SUCCESS'
const RESERVATION__CHECKIN_FAILURE = 'RESERVATION__CHECKIN_FAILURE'

const initialState = {
    reservations: {},
    inventory: {},
}

export const actionCreators = {
    getInventoryList: (filterDt) =>
        api({
            types: [RESERVATION__GET_INVENTORY_REQUEST, RESERVATION__GET_INVENTORY_SUCCESS, RESERVATION__GET_INVENTORY_FAILURE],
            uri: `/api/inventory?q=${filterDt}`,
            config: {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            },
        }),
    getReservation: (confirmationNumber) =>
        api({
            types: [RESERVATION__GET_CONFIRMATION_REQUEST, RESERVATION__GET_CONFIRMATION_SUCCESS, RESERVATION__GET_CONFIRMATION_FAILURE],
            uri: `/api/reservation/${confirmationNumber}`,
            config: {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            },
            sendJwtBearer: false,
        }),
    getReservations: (id) =>
        api({
            types: [RESERVATION__GET_REQUEST, RESERVATION__GET_SUCCESS, RESERVATION__GET_FAILURE],
            uri: id ? `/api/reservation/reservationId/${id}` : '/api/reservation',
            config: {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            },
            sendJwtBearer: true,
        }),
    updateReservation: (reservation) =>
        api({
            types: [RESERVATION__UPDATE_RESERVATION_REQUEST, RESERVATION__UPDATE_RESERVATION_SUCCESS, RESERVATION__UPDATE_RESERVATION_FAILURE],
            uri: '/api/reservation',
            config: {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(reservation),
            },
            payload: reservation,
            sendJwtBearer: false,
        }),
    checkInReservation: (checkin) =>
        api({
            types: [RESERVATION__CHECKIN_REQUEST, RESERVATION__CHECKIN_SUCCESS, RESERVATION__CHECKIN_FAILURE],
            uri: `/api/reservation/${checkin.confirmationNumber}/checkin`,
            config: {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(checkin),
            },
            payload: checkin,
            sendJwtBearer: true,
        }),
}

const reservations = (state = initialState.reservations, action) => {
    switch (action.type) {
        case RESERVATION__GET_SUCCESS:
            return {
                ...state,
                ...action.response.reduce((obj, item) => {
                    obj[item.id] = item
                    return obj
                }, {}),
            }
        default:
            return { ...state }
    }
}

const inventory = (state = initialState.inventory, action) => {
    switch (action.type) {
        case RESERVATION__GET_INVENTORY_SUCCESS:
            return {
                // ...state,
                ...action.response.reduce((obj, item) => {
                    obj[item.inventoryBlockId] = item
                    return obj
                }, {}),
            }
        default:
            return { ...state }
    }
}

export const reducer = combineReducers({
    reservations,
    inventory,
})
